// Genre inference for The Resilience Studios Musical Collection.
// Founder plain-ink 2026-07-02+: toggle by-genre AND by-band on /artists.
//
// Each artist can carry multiple genre tags. Genres are derived from the
// combined `lane` + `reference` free-text on artists.js so we don't have
// to hand-maintain a second field.

const GENRE_MAP = [
  // [genre-label, [keyword, keyword, ...]]
  ["Rock", ["rock", "alt-rock", "art-rock", "stadium", "grunge", "post-grunge", "art-punk"]],
  ["Country", ["country", "outlaw-country", "bro-country", "americana", "nashville"]],
  ["Pop", ["pop", "torch-pop", "dance-pop", "swedish-pop"]],
  ["Metal", ["metal", "thrash", "iron"]],
  ["K-Pop", ["k-pop", "kpop", "k-POP"]],
  ["Jam", ["jam", "jam-band", "grateful dead", "phish", "dave matthews", "steely dan"]],
  ["R&B / Soul", ["soul", "r&b", "neo-soul", "torch-soul", "old-soul", "motown"]],
  ["Hip-Hop", ["rap", "hip-hop", "mc"]],
  ["Reggae", ["reggae", "one-drop", "ska", "surf-punk"]],
  ["Punk", ["punk", "pop-punk", "mall-rock"]],
  ["Folk", ["folk", "bluegrass", "mummers", "celtic", "acoustic"]],
  ["Electronic", ["electronic", "electro", "house", "daft", "vocoder"]],
  ["Prog", ["prog", "atmospheric-prog", "prog-rock", "pink floyd"]],
  ["Opera", ["opera", "operatic", "queen"]],
  ["Industrial", ["industrial", "nine inch nails", "trent reznor"]],
  ["Soft-Rock", ["soft-rock", "fleetwood", "california", "rumours"]],
  ["Indie", ["indie", "chameleon"]],
  ["New-Wave", ["new-wave", "talking heads", "afrobeat"]],
  ["Blues", ["blues", "hard-blues", "heavy-blues"]],
  ["Experimental", ["puscifer", "trip-hop", "experimental", "masked-collective"]],
];

export function inferGenres(artist) {
  const hay = `${artist.lane || ""} ${artist.reference || ""} ${artist.tagline || ""}`
    .toLowerCase();
  const found = new Set();
  for (const [label, kws] of GENRE_MAP) {
    for (const k of kws) {
      if (hay.includes(k.toLowerCase())) {
        found.add(label);
        break;
      }
    }
  }
  if (found.size === 0) found.add("Other");
  return Array.from(found);
}

export function allGenres(artists) {
  const set = new Set();
  for (const a of artists) {
    for (const g of inferGenres(a)) set.add(g);
  }
  return Array.from(set).sort();
}

export function artistMatchesFilters(artist, activeGenres, disabledBands) {
  if (disabledBands && disabledBands.has(artist.slug)) return false;
  if (!activeGenres || activeGenres.size === 0) return true;
  const gs = inferGenres(artist);
  return gs.some((g) => activeGenres.has(g));
}
